import { render } from "./Tokens.vue?vue&type=template&id=1db9593b"
import script from "./Tokens.vue?vue&type=script&lang=js"
export * from "./Tokens.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__